import { Dic } from "$utils";
export const permissionOption = function () {
  return {
    add: "新增",
    edit: "修改",
    view: "查看",
    page: true,
    selection: true,
    index: false,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: "：",
    align: "left",
    size: "small",
    maxHeight: "100%",
    labelWidth: "110px",
    labelPosition: "right",
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 150,
    dialogWidth: "600px",
    emptyText: "暂无数据",
    menu: false,
    column: [
      {
        label: "权限组名称",
        prop: "authGroupName",
        search: true,
        hide: false,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: false,
        span: 24,
        align: "center",
        rules: [
          {
            required: true,
            message: "请输入权限组名称",
            trigger: "blur"
          }
        ]
      },
      // {
      //   label: '操作账号',
      //   prop: 'dataType',
      //   search: false,
      //   addDisplay: false,
      //   editDisplay: false,
      //   viewDisplay: false,
      //   editDisabled: false,
      //   overHidden: true,
      //   align: 'center',
      //   span: 12,
      // },
      {
        label: "创建人",
        prop: "creator",
        search: false,
        clearable: true,
        hide: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        span: 12
      },
      {
        label: "创建时间",
        prop: "createTime",
        search: false,
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        align: "right",
        span: 12
      },
      {
        label: "修改人",
        prop: "modifier",
        search: false,
        clearable: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        editDisabled: false,
        overHidden: true,
        align: "center",
        span: 12
      },
      {
        label: "修改时间",
        prop: "modifyTime",
        search: false,
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        align: "right",
        span: 12
      },
      {
        label: "描述",
        prop: "desc",
        search: false,
        overHidden: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: false,
        align: "right",
        type: "textarea",
        span: 24,
        rules: 
          {
            required: true,
            message: "请输入描述",
            trigger: "blur"
          }
        
      }
    ]
  };
};
